/**
 * Bootstrap
 * https://getbootstrap.com/
 */
require('./bootstrap');

/**
 * Alpine.js
 * https://github.com/alpinejs/alpine
 */
import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'

Alpine.plugin(focus)

window.Alpine = Alpine
 
Alpine.start()

/**
 * toastr
 * https://github.com/CodeSeven/toastr
 */
window.toastr = require('toastr');

/**
 * Fontawesome icons
 */
require('./fontawesome');

/**
 * Custom functions
 */
require('./helpers');